<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Industries</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateIndustry()">
        <mat-icon>add</mat-icon>
        Add Industry
      </button>
    </div>
  </div>
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node">
      <div class="mat-tree-node industry-node" [matTreeNodePadding]="true" [matTreeNodePaddingIndent]="22" (click)="selectNode(node); $event.stopPropagation()">
        <div class="mat-tree-node-spacer"></div>
        <div class="mat-tree-node-content" [class.selected]="selectedNode && getId(selectedNode) === getId(node)" [attr.id]="selectedNode && getId(selectedNode) === getId(node) ? 'selected-tree-node' : null">
          @if (isEditing(node)) {
            <mat-form-field appearance="fill" class="edit-field">
              <input matInput
                     [(ngModel)]="editingValue"
                     (keydown)="onEditKeyDown($event, node)"
                     (click)="onEditInputClick($event)"
                     #editInput>
            </mat-form-field>
            <div class="edit-actions">
              <button mat-icon-button
                      (click)="saveEdit(node); $event.stopPropagation()"
                      class="save-button"
                      [disabled]="!editingValue.trim()">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button
                      (click)="cancelEdit(); $event.stopPropagation()"
                      class="cancel-button">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          } @else {
            <span class="node-name" [class.empty]="!node.name">{{ getName(node) }}</span>
            <div class="node-actions">
              <button mat-icon-button
                      (click)="startEdit(node, $event)"
                      class="edit-button">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button
                      (click)="onDeleteIndustry(node); $event.stopPropagation()"
                      class="delete-button">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    </mat-tree-node>
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
      <div class="mat-tree-node industry-node" [matTreeNodePadding]="true" [matTreeNodePaddingIndent]="16">
        <button mat-icon-button matTreeNodeToggle type="button" [attr.aria-label]="'Toggle ' + getName(node)" (click)="$event.stopPropagation(); $event.preventDefault()">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        <div class="mat-tree-node-content" (click)="selectNode(node); $event.stopPropagation()" [class.selected]="selectedNode && getId(selectedNode) === getId(node)" [attr.id]="selectedNode && getId(selectedNode) === getId(node) ? 'selected-tree-node' : null">
          @if (isEditing(node)) {
            <mat-form-field appearance="fill" class="edit-field">
              <input matInput
                     [(ngModel)]="editingValue"
                     (keydown)="onEditKeyDown($event, node)"
                     (click)="onEditInputClick($event)"
                     #editInput>
            </mat-form-field>
            <div class="edit-actions">
              <button mat-icon-button
                      (click)="saveEdit(node); $event.stopPropagation()"
                      class="save-button"
                      [disabled]="!editingValue.trim()">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button
                      (click)="cancelEdit(); $event.stopPropagation()"
                      class="cancel-button">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          } @else {
            <span class="node-name" [class.empty]="!node.name">{{ getName(node) }}</span>
            <div class="node-actions">
              <button mat-icon-button
                      (click)="startEdit(node, $event)"
                      class="edit-button">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button
                      (click)="onDeleteIndustry(node); $event.stopPropagation()"
                      class="delete-button">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
      <div [class.mat-tree-invisible]="!treeControl.isExpanded(node)" role="group">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </mat-nested-tree-node>
  </mat-tree>
</div>
